module.exports = "/_next/static/media/d2b71a1c3e6231c0e58ee9eea820102e.svg";